import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import {Link, withRouter} from 'react-router-dom'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import BILLogo from '../../assets/img/BIL.svg'
import HomeIcon from '../../assets/img/icons/home.svg'
import FlagIcon from '../../assets/img/icons/flag.svg'
import ShoppingBagIcon from '../../assets/img/icons/shopping-bag.svg'
import SupportIcon from '../../assets/img/icons/support.svg'
import KpisIcon from '../../assets/img/icons/kpis.svg'
import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import {connect} from 'react-redux'
import {getAccessToken, logOut} from '../reducers/asciidoc/Auth/action'
import {getMenu} from '../reducers/asciidoc/action'
import Cookies from 'universal-cookie'
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import SettingsIcon from '@material-ui/icons/Settings';
import MenuIcon from '@material-ui/icons/Menu';
import '../../assets/style/header.scss'
import {MenuItem, Select, Typography} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';


const cookies = new Cookies();

const styles = theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0
    },
    grow: {
        flexGrow: 1,
    },
    toolBar: {
        minHeight: '75px'
    },
    appBar: {
        background: '#4F2161',
        zIndex: 9,
        position: 'relative',
        boxShadow: 'none!important'
    },
    getStartedText: {
        marginRight: "-7px",
        fontFamily: "MontSerrat",
        fontSize: "14px"
    },
    selectPaper: {
        marginLeft: "-55px",
        "& .MuiSelect-select.MuiSelect-select": {
            paddingRight: "50px"
        }
    },
    select: {
        color: "white  !important",
        // fontFamily: "Montserrat",
        // fontSize: "14px",
        // paddingLeft: "10px",
        // paddingRight: "14px",
        paddingTop: "1px",
        // cursor: "pointer !important",
        "& .MuiSelect-select.MuiSelect-select": {
            paddingRight: "0"
        }
    },
    tabs: {
        marginLeft: '40px',
        '@media screen and (max-width: 1061px) and (min-width: 768px)': {
            marginLeft: 'unset'
        }
    },
    tab: {
        minHeight: '75px',
        '&:hover': {
            opacity: 1,
            color: 'white'
        },
        textTransform: 'none',
        fontSize: '16px!important'
    },
    loginButton: {
        fontFamily: 'Montserrat !important',
        marginTop: '5px',
        marginLeft: 'auto',
        padding: '5px 30px',
        color: 'white',
        '&:hover': {
            color: 'white'
        },
        whiteSpace: "nowrap",
        border: "1px solid white",
        borderRadius: "5px"

    },
    userButton: {
        marginLeft: 'auto',
        // border: '1px solid white',
        padding: '5px 30px',
        borderRadius: 0,
        color: 'white',
        backgroundColor: 'transparent',
        border: 'none',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&:focus': {
            outline: 'none',
        }
    },
    userIcon: {
        marginRight: '10px',
        marginBottom: '3px'
    },
    userMenu: {
        marginTop: '35px',
        marginLeft: '-30px',
        width: '200px'
    },
    chevronIcon: {
        marginLeft: '10px'
    },
    indicator: {
        top: 80,
        height: "40px",
        marginTop: "-60px",
        pointerEvents: "none",
        cursor: "pointer",
        backgroundColor: "transparent",
        border: "1px solid white",
        borderRadius: "5px"
    },
    scrollButtons: {
        paddingLeft: "50px",
        paddingRight: "80px"
    },
    icon: {
        marginRight: '10px'
    }
});

class Header extends React.Component {

    state = {
        value: 0,
        anchorEl: null,
        showMenuLeft: false,
        openGetStarted: false,
        showMarked: true
    };

    componentDidMount() {
        const {getMenu} = this.props;
        const {pathname} = this.props.location;

        getMenu();

        if (pathname === '/get-started' && this.props.connected) {
            cookies.set('first_connection', false);
            this.setState({showMarked: false});
        }

        this.activeLink(pathname);

        this.props.history.listen((location) => {
            this.activeLink(location.pathname);
        })
    }

    activeLink(pathname) {
        let element;
        switch (pathname) {
            case '/':
                element = document.getElementById("home-nav-tab");
                this.setState({value: 0});
                break;
            case '/get-started':
            case '/get-started-v2':
                element = document.getElementById("get-started-nav-tab");
                this.setState({value: 1});
                break;
            case '/catalog':
            case '/overview':
                element = document.getElementById("catalog-nav-tab");
                this.setState({value: 2});
                break;
            case '/support':
                element = document.getElementById("support-nav-tab");
                this.setState({value: 3});
                break;
            case '/kpis':
                element = document.getElementById("kpis-nav-tab");
                this.setState({value: 4});
                break;
            default:
                this.setState({value: 0})
        }
    }

    handleChange = (event, value) => {
        if (value === 0) {
            this.handleClickLink(event, value);
            this.props.history.push("/");
        } else if (value === 1) {
            this.props.history.push("/get-started-v2");
        } else if (value === 2) {
            this.handleClickLink(event, value);
            this.props.history.push("/catalog");
        } else if (value === 3) {
            this.handleClickLink(event, value);
            this.props.history.push("/support");
        } else if (value === 4) {
            document.location.href = "https://www.bil.com/api-performance";
        } else if (value === 5) {
            this.setState({value});
            document.location.href = window.urlAPIs;
        } else if (value === 6) {
            this.setState({value});
            document.location.href = window.urlAPPs;
        } else if (value === 99) {
            this.setState({value});
            if (this.props.connected) {
                cookies.set('first_connection', false);
                this.setState({showMarked: false});
            }
            this.props.history.push("/get-started");
        } else {
            this.handleClickLink(event, value);
        }
        this.render();
    };

    handleClick = event => {
        this.setState({anchorEl: event.currentTarget});
    };

    handleClose = () => {
        this.setState({anchorEl: null});
    };

    handleLogOut = () => {
        const {logOut} = this.props;
        this.setState({anchorEl: null});
        logOut();
        this.props.history.push('/');
    };

    handleOpenMenuLeft = () => {
        const {value} = this.state;
        this.setState({showMenuLeft: true});
        if (value === 1) {
            this.setState({openGetStarted: true});
        } else {
            this.setState({openGetStarted: false});
        }
    };

    handleCloseMenuLeft = () => {
        this.setState({showMenuLeft: false});
    };

    handleClickLink = (event, value) => {
        this.setState({value: value});
        this.handleCloseMenuLeft();
    };

    handleClickOpenGetStareted = (value) => {
        this.setState({openGetStarted: value});
    };

    render() {

        window.addEventListener('scroll', function () {
            const buttonMenuLeft = document.getElementsByClassName("button-menu-left")[0];
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            let scrollWidth = document.documentElement.scrollWidth || document.body.scrollWidth;

            if (scrollTop > 30 || scrollWidth >= 768) {
                buttonMenuLeft.style.display = "none";
            } else {
                buttonMenuLeft.style.display = "block";
            }
        }, true);

        window.addEventListener('resize', function () {
            const buttonMenuLeft = document.getElementsByClassName("button-menu-left")[0];
            let scrollWidth = document.documentElement.scrollWidth || document.body.scrollWidth;

            if (scrollWidth >= 768) {
                buttonMenuLeft.style.display = "none";
            } else {
                buttonMenuLeft.style.display = "block";
            }
        }, true);

        const {classes, connected} = this.props;
        const {value, anchorEl, showMenuLeft, username} = this.state;

        const usernameShow = cookies.get('user') !== "null" ? cookies.get('user') : username;
        const menus = cookies.get('menus');

        let menuLink = [
            {
                // border: "1px solid white", borderRadius: "5px", padding: "0px 20px 2px 20px",
                label: <Typography id={"home-nav-tab"} style={{fontFamily: "Montserrat", fontSize: "14px"}}><Icon><img
                    style={{marginRight: "5px", marginBottom: "3px"}} alt="Home"
                    src={HomeIcon}/></Icon> Home</Typography>, path: '/', marked: false
            },
            {
                label: <Typography id={"get-started-nav-tab"} style={{marginRight: "-7px", fontFamily: "Montserrat", fontSize: "14px"}}><Icon><img
                    style={{ marginBottom: "3px"}} alt="Get Started" src={FlagIcon}/></Icon>&nbsp;&nbsp;Get
                    Started <ArrowDropDownIcon style={{}} /></Typography>,
                path: '/get-started-v2',
                marked: false,
                action: this.handleChange,
                currentValue: this.state.value
            },
            {
                label: <Typography id={"catalog-nav-tab"} style={{fontFamily: "Montserrat", fontSize: "14px"}}><Icon><img
                    style={{marginRight: "5px", marginBottom: "3px"}} alt="Catalog"
                    src={ShoppingBagIcon}/></Icon> API Catalog</Typography>, path: '/catalog', marked: false
            },
            {
                label: <Typography id={"support-nav-tab"} style={{fontFamily: "Montserrat", fontSize: "14px"}}><Icon><img
                    style={{marginRight: "5px", marginBottom: "3px"}} alt="Catalog"
                    src={SupportIcon}/></Icon> Support</Typography>, path: '/support', marked: false
            },
            {
                label: <Typography id={"kpis-nav-tab"} style={{fontFamily: "Montserrat", fontSize: "14px"}}><Icon><img
                    style={{marginRight: "5px", marginBottom: "3px"}} alt="Catalog"
                    src={KpisIcon}/></Icon> KPIs</Typography>, path: '/kpis', marked: false
            }
        ];

        let menusHtml = '';
        if (menus && menus !== "null" && menus.length > 0) {
            menus.forEach(function (menu) {
                menuLink.push(
                    {
                        label: <Typography
                            style={{fontFamily: "Montserrat", fontSize: "14px"}}><Icon></Icon> {menu.title}
                        </Typography>, path: menu.href, marked: false
                    }
                );
            });
            menusHtml = menus.map((menu, key) => {
                return <li key={key}><a href={menu.href}>{menu.title}</a></li>
            })
        }

        return (
            <div className={showMenuLeft ? "show-menu-left-container" : ""} onClick={showMenuLeft ? this.handleCloseMenuLeft : null}>
                {showMenuLeft &&
                    <div className="menu-left">
                        <button className="btn btn-link" id="close-menu-left"
                                onClick={this.handleCloseMenuLeft}></button>
                        <div className="logo-bil text-center">
                            <Typography style={{fontFamily: "Montserrat", fontSize: "14px"}}><Icon><img
                                style={{width: "40.51px", height: "32px", marginRight: "10px", marginTop: "2px"}}
                                alt="BIL Logo" src={BILLogo}/></Icon>
                                <span className="header-logo-title">
                                Open Banking Portal
                            </span>
                            </Typography>
                        </div>
                        <ul>
                            <li className={value === 0 ? 'active' : ''}><Link to="/" onClick={(evt) => {
                                this.handleClickLink(evt, 0)
                            }}>Home</Link></li>
                            <li className={"/get-started-v2" === this.props.history.location.pathname ? 'active' : ''}>
                                <Link to="/get-started-v2" onClick={(evt) => {
                                    this.handleClickLink(evt, 1)
                                }}>Get Started - Start as TPP</Link></li>
                            <li className={"/get-started" === this.props.history.location.pathname ? 'active' : ''}>
                                <Link to="/get-started" onClick={(evt) => {
                                    this.handleClickLink(evt, 99)
                                }}>Get Started - Start as TPP (Stet deprecated)</Link></li>
                            <li className={value === 2 ? 'active' : ''}><Link to="/catalog" onClick={(evt) => {
                                this.handleClickLink(evt, 2)
                            }}>API Catalog</Link></li>
                            <li className={value === 3 ? 'active' : ''}><Link to="/support" onClick={(evt) => {
                                this.handleClickLink(evt, 3)
                            }}>Support</Link></li>
                            <li><a href="https://www.bil.com/api-performance">KPIs</a></li>
                            {menusHtml}
                        </ul>
                    </div>
                }
                <div className={classes.root}>
                    <AppBar position="static"
                            style={{background: isV2Path(this.props.history.location.pathname) ? "#4F2161" : "linear-gradient(to right, #8f227c, #5b1c77 30%)"}}
                            className={classes.appBar}>
                        <Toolbar className={`${classes.toolBar} toolbar-app`}>
                            <div className="button-menu-left">
                                <button className="btn btn-link" id="open-menu-left" onClick={this.handleOpenMenuLeft}>
                                    <MenuIcon/></button>
                            </div>
                            <Typography style={{fontFamily: "Montserrat", fontSize: "14px"}}><Icon><img
                                className={"header-logo"} alt="BIL Logo" src={BILLogo}/></Icon>
                                <span className="header-logo-title">
                                Open Banking Portal
                            </span>
                            </Typography>
                            {menuLink &&
                                <Tabs value={value} onChange={this.handleChange}
                                      classes={{indicator: classes.indicator, scrollButtons: classes.scrollButtons}} className={`${classes.tabs} tabs-app`}
                                      variant="scrollable">
                                    {
                                        menuLink.map(function (item, key) {
                                            if ("/get-started-v2" === item.path) {
                                                return <Tab key={`menulink-${key}`} value={key} label={
                                                    <Select
                                                        MenuProps={{
                                                            classes: {paper: classes.selectPaper},
                                                            anchorOrigin: {
                                                                vertical: 'bottom',
                                                                horizontal: 'left',
                                                            },
                                                            transformOrigin: {
                                                                vertical: 'top',
                                                                horizontal: 'left',
                                                            },
                                                            getContentAnchorEl: null,
                                                        }}
                                                        id={"get-started-select-input"}
                                                        style={{opacity: item.currentValue === 1 ? "unset" : "1"}}
                                                        defaultValue={"Get Started"}
                                                        value={"Get Started"}
                                                        className={classes.select}
                                                        inputProps={{'aria-label': 'Without label'}}
                                                        // onChange={item.action}
                                                        onChange={(event) => {
                                                            event.stopPropagation();
                                                            item.action(event, event.target.value)
                                                        }}
                                                    >
                                                        <MenuItem style={{display: "none"}} value={"Get Started"}
                                                                  disabled>{item.label}</MenuItem>
                                                        <MenuItem value={1}>Start as TPP</MenuItem>
                                                        <MenuItem value={99}>Start as TPP (Stet deprecated)</MenuItem>
                                                    </Select>
                                                }
                                                            className={`${classes.tab} ${item.marked ? 'marked' : ''} ${key === value ? 'tab-active' : ''}`}
                                                            disableRipple
                                                            disableFocusRipple/>

                                                // return <React.Fragment>
                                                //     <Select
                                                //         MenuProps={{
                                                //             classes: { paper: classes.selectPaper},
                                                //             anchorOrigin: {
                                                //                 vertical: 'bottom',
                                                //                 horizontal: 'left',
                                                //             },
                                                //             transformOrigin: {
                                                //                 vertical: 'top',
                                                //                 horizontal: 'left',
                                                //             },
                                                //             getContentAnchorEl: null,
                                                //         }}
                                                //         id={"get-started-select-input"}
                                                //         style={{opacity: item.currentValue === 1 ? "unset" : "0.7"}}
                                                //         defaultValue={"Get Started"}
                                                //         value={"Get Started"}
                                                //         className={classes.select}
                                                //         inputProps={{'aria-label': 'Without label'}}
                                                //         // onChange={item.action}
                                                //         onChange={(event) => {
                                                //             item.action(event, event.target.value)
                                                //         }}
                                                //     >
                                                //         <MenuItem style={{display: "none"}} value={"Get Started"}
                                                //                   disabled>{item.label}</MenuItem>
                                                //         <MenuItem value={99}>Start as TPP</MenuItem>
                                                //         <MenuItem value={1}>Start as TPP (Stet deprecated)</MenuItem>
                                                //     </Select>
                                                //
                                                // </React.Fragment>
                                            } else if ("/catalog" === item.path) {
                                                return <Tab key={`menulink-${key}`} value={key} label={item.label}
                                                            style={{marginLeft: "16px"}} className={`${classes.tab} ${item.marked ? 'marked' : ''} ${key === value ? 'tab-active' : ''}`} disableRipple
                                                            disableFocusRipple />
                                            } else {
                                                return <Tab key={`menulink-${key}`} value={key} label={item.label}
                                                            className={`${classes.tab} ${item.marked ? 'marked' : ''} ${key === value ? 'tab-active' : ''}`} disableRipple
                                                            disableFocusRipple />
                                            }
                                        })
                                    }
                                </Tabs>
                            }
                            {!connected &&
                                <React.Fragment>
                                    <a href={window.urlSSO}
                                       className={`${classes.loginButton} login-button`}>
                                        <VpnKeyIcon
                                        className={classes.userIcon}/>
                                        Log in</a>
                                </React.Fragment>
                            }
                            {connected &&
                                <React.Fragment>
                                    <Button
                                        aria-owns={anchorEl ? 'menu-user' : undefined}
                                        aria-haspopup="true"
                                        onClick={this.handleClick}
                                        className={classes.userButton}
                                    >
                                        <AccountCircleIcon className={classes.userIcon}/>
                                        <span>{usernameShow}</span>
                                        <KeyboardArrowDownIcon className={classes.chevronIcon}/>
                                    </Button>
                                    <Menu
                                        id="menu-user"
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={this.handleClose}
                                    >
                                        <div className="text-center btn-logout">
                                            <button className="btn btn-blue" onClick={this.handleLogOut}>LOG OUT
                                            </button>
                                        </div>
                                        <hr/>
                                        <div className="text-center link-manage">
                                            <a href="/portal/login"><SettingsIcon style={{marginLeft: '10px'}}
                                                                                  className={classes.userIcon}/> <span
                                                style={{marginRight: '10px'}}> Manage settings</span></a>
                                        </div>
                                    </Menu>
                                </React.Fragment>
                            }
                        </Toolbar>
                    </AppBar>
                </div>
            </div>
        );
    }
}

function isV2Path(pathname) {
    switch (pathname) {
        case '/':
        case '/get-started-v2':
        case '/catalog':
        case '/support':
        case '/kpis':
        case '/overview':
            return true;
        default:
            return false
    }
}

Header.propTypes = {
    classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    let isConnected = state.AccessToken.connected ? state.AccessToken.connected : cookies.get('isConnected');
    return {
        connected: JSON.parse(isConnected),
        firstConnection: state.AccessToken.firstConnection,
        username: state.AccessToken.username
    }
}

const mapDispatchToProps = {
    getAccessToken,
    logOut,
    getMenu
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(Header)));